// Source: app/scripts/services/simplified-procedure-validation-service.js
Auction.factory('SimplifiedProcedureValidation', ['settings', 'toaster', '$filter', 'dateParse', function (settings, toaster, $filter, dateParse) {

  function parseDate(value) {
    var parsed = dateParse.parse(value);
    if (!parsed) {
      return null;
    }
    return moment(parsed).startOf('day');
  }

  function isEndBeforeStart(start, end) {
    var startDate = parseDate(start);
    var endDate = parseDate(end);
    if (!startDate || !endDate) {
      return false;
    }
    return endDate.isBefore(startDate, 'day');
  }

  function validateDateRanges(simplifiedProcedure) {
    var errors = [];

    if (!simplifiedProcedure) {
      return errors;
    }

    if (isEndBeforeStart(simplifiedProcedure.guaranteeValidFrom, simplifiedProcedure.guaranteeValidTo)) {
      errors.push('portal.simplified_guarantee_valid_to_before_valid_from');
    }

    if (isEndBeforeStart(simplifiedProcedure.validFrom, simplifiedProcedure.validTo)) {
      errors.push('portal.simplified_authorization_valid_to_before_valid_from');
    }

    return errors;
  }

  function validateCustomsWarehouseDateRanges(customsWarehouse) {
    var errors = [];

    if (!customsWarehouse) {
      return errors;
    }

    if (isEndBeforeStart(customsWarehouse.dateFrom, customsWarehouse.dateTo)) {
      errors.push('portal.customs_warehouse_authorization_valid_to_before_valid_from');
    }

    return errors;
  }

  return {
    validateDateRanges: validateDateRanges,
    validateCustomsWarehouseDateRanges: validateCustomsWarehouseDateRanges,

    showDateRangeErrors: function (errorKeys) {
      if (!errorKeys || !errorKeys.length) {
        return;
      }

      angular.forEach(errorKeys, function (errorKey) {
        toaster.pop(
          'error',
          $filter('translate')('generic.error'),
          $filter('translate')(errorKey)
        );
      });
    },

    validateAndNotify: function (simplifiedProcedure) {
      var errors = validateDateRanges(simplifiedProcedure);
      if (errors.length) {
        this.showDateRangeErrors(errors);
        return false;
      }
      return true;
    },

    validateCustomsWarehouseAndNotify: function (customsWarehouse) {
      var errors = validateCustomsWarehouseDateRanges(customsWarehouse);
      if (errors.length) {
        this.showDateRangeErrors(errors);
        return false;
      }
      return true;
    }
  };
}]);
